import {
  ALL_INTENTS,
  ALL_AGENTS,
  SET_SELECTED_AGENT,
  CURRENT_AGENT_DETAILS,
  GET_ALL_DEPLOYMENTS,
  SET_DEPLOYMENTS_LOADER,
  SET_TRAINING_LOADER,
  GET_DEPLOYMENTS,
  TRAINING_UTTERANCES,
  TRAINING_UTTERANCES_NOT_FOUND,
  TRAINING_SESSION_DATA_NOT_FOUND,
  TRAINING_SESSION_DATA,
  SET_TRAINING_SESSIONS_LOADER,
  CREATE_INTENT,
  CREATE_INTENT_INPUT,
} from '../types/conversationNew';

const initialState = {
  deploymentsLoader: false,
  trainingLoader: false,
  allDeployments: [],
  trainingUtterances: [],
  trainingNotFound: false,
  sessionsLoader: false,
  sessionDataNotFound: false,
  sessionData: null,
  allIntents: [],
};

export const conversationNewReducer = (state = initialState, action) => {
  switch (action.type) {
    case ALL_INTENTS: {
      const allIntents = action.payload.map((item) => ({
        value: item.id,
        label: item.intent_name,
        ...item,
      }));
      return { ...state, allIntents, allIntentsNew: action.payload };
    }
    case ALL_AGENTS: {
      return { ...state, allAgents: action.payload };
    }
    case CURRENT_AGENT_DETAILS: {
      return {
        ...state,
        agentDetails: action.payload,
        conversationAvatar: action.payload.avatar,
        conversationTitle: action.payload.agent_name,
      };
    }
    case SET_SELECTED_AGENT: {
      return {
        ...state,
        selectedAgent: action.payload,
      };
    }
    case GET_ALL_DEPLOYMENTS: {
      return { ...state, allDeployments: action.payload };
    }
    case SET_DEPLOYMENTS_LOADER: {
      return { ...state, deploymentsLoader: action.status };
    }
    case SET_TRAINING_LOADER: {
      return { ...state, trainingLoader: action.status };
    }
    case GET_DEPLOYMENTS: {
      return { ...state, allDeployments: action.payload };
    }
    case TRAINING_UTTERANCES: {
      return {
        ...state,
        trainingUtterances: action.payload.content,
        trainingPageNumber: action.payload.number,
        trainingTotalPages: action.payload.totalPages,
        trainingIsEmpty: action.payload.empty,
        trainingPageSize: action.payload.size,
        trainingNotFound: false,
      };
    }
    case TRAINING_UTTERANCES_NOT_FOUND: {
      return {
        ...state,
        trainingNotFound: true,
      };
    }
    case SET_TRAINING_SESSIONS_LOADER: {
      return { ...state, sessionsLoader: action.status };
    }
    case TRAINING_SESSION_DATA_NOT_FOUND: {
      return {
        ...state,
        sessionDataNotFound: true,
      };
    }
    case TRAINING_SESSION_DATA: {
      const { session_id, status, no_matches, responses } = action.payload;

      const trainingUtterances = state.trainingUtterances.map((utterance) => {
        if (utterance.session_id === session_id) {
          return {
            ...utterance,
            status,
            no_matches,
            responses,
          };
        }
        return utterance;
      });

      return {
        ...state,
        trainingUtterances,
        sessionData: action.payload,
        sessionDataNotFound: false,
      };
    }
    case CREATE_INTENT: {
      const allIntents = state.allIntents;
      const intent = {
        value: action.payload.id,
        label: action.payload.intent_name,
        ...action.payload,
      };
      return {
        ...state,
        allIntents: allIntents.length > 0 ? [...allIntents, intent] : [intent],
      };
    }
    case CREATE_INTENT_INPUT: {
      const records = state.sessionData.user_records;
      const recordIndex = records.findIndex(
        (item) =>
          item.user_message.toLowerCase() ===
          action.payload.input_value.toLowerCase()
      );
      const affectedRecord = recordIndex < 0 ? null : records[recordIndex];
      const changedRecord = {
        ...affectedRecord,
        response_intent: action.intent,
        is_match: true,
        is_flagged: false,
      };
      return {
        ...state,
        sessionData: {
          ...state.sessionData,
          user_records: [
            ...records.slice(0, recordIndex),
            changedRecord,
            ...records.slice(recordIndex + 1),
          ],
        },
      };
    }
    default:
      return state;
  }
};
